import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Checkbox({ checked, disabled, onChange, children }) {
    return (_jsxs("label", { className: "checkbox", disabled: disabled, children: [_jsx("input", { type: "checkbox", disabled: disabled, checked: checked, onChange: onChange }), " ", children] }));
}
//# sourceMappingURL=Checkbox.js.map